<!-- One hidden input shared by "Upload" and "Upload corrected file" -->
<input #fileInput type="file" class="visually-hidden" accept=".xlsx" tabindex="-1" aria-hidden="true"
  (change)="onFileChosen($event)">

<!-- ============ Review screen ============ -->
<app-review-upload *ngIf="view == 'review' && review"
  [result]="review"
  [uploadedBy]="uploadedBy"
  [busy]="busy"
  (uploadCorrected)="openFilePicker()"
  (discard)="discard()"
  (publish)="publish()">
</app-review-upload>

<!-- ============ Schedule detail ============ -->
<app-schedule-detail *ngIf="view == 'detail' && detail"
  [detail]="detail"
  [busy]="busy"
  (back)="backToCalendar()"
  (editRequest)="openDialog('edit')"
  (cancelRequest)="openDialog('cancel')"
  (checkRequest)="openCheck()">
</app-schedule-detail>

<!-- ============ Patching calendar ============ -->
<section class="pc" *ngIf="view == 'calendar'">
  <header class="pc-head">
    <div>
      <h2 class="pc-title">Patching calendar</h2>
      <p class="pc-sub">{{ customerName || 'All customers' }} &middot; all application teams</p>
    </div>
    <div class="pc-actions">
      <!-- <button type="button" class="btn-outline" disabled title="Coming soon">
        <i class="fa fa-calendar" aria-hidden="true"></i> Calendar view
      </button> -->
      <button type="button" class="btn-outline" [disabled]="busy != 'idle'" (click)="openFilePicker()">
        <i class="fa fa-upload" aria-hidden="true"></i> Upload
      </button>
    </div>
  </header>

  <!-- KPIs -->
  <dl class="kpis">
    <div class="kpi">
      <dt>Upcoming windows</dt>
      <dd>{{ upcomingWindows }}</dd>
    </div>
    <div class="kpi">
      <dt>Instances scheduled</dt>
      <dd>{{ instancesScheduled }}</dd>
    </div>
    <div class="kpi">
      <dt>Open deviations</dt>
      <dd [class.kpi-warn]="openDeviations > 0">{{ openDeviations }}</dd>
    </div>
    <div class="kpi">
      <dt>Last run</dt>
      <dd [class.kpi-ok]="lastRunOk" [class.kpi-warn]="lastRun && !lastRunOk">
        {{ lastRun ? lastRun.success_pct + '%' : '\u2014' }}
        <span class="kpi-sub" *ngIf="lastRun">{{ lastRunDetail }}</span>
      </dd>
    </div>
  </dl>

  <!-- Filters -->
  <div class="filters">
    <label class="search">
      <span class="visually-hidden">Search schedules</span>
      <i class="fa fa-search" aria-hidden="true"></i>
      <input type="search" placeholder="Search" [value]="search"
        (input)="search = $any($event.target).value">
    </label>
    <select aria-label="Filter by team" (change)="team = $any($event.target).value">
      <option value="" [selected]="!team">All teams</option>
      <option *ngFor="let t of filterOptions.teams" [value]="t" [selected]="t == team">{{ t }}</option>
    </select>
    <select aria-label="Filter by status" (change)="status = $any($event.target).value">
      <option value="" [selected]="!status">All statuses</option>
      <option *ngFor="let s of filterOptions.statuses" [value]="s" [selected]="s == status">{{ s }}</option>
    </select>
  </div>

  <!-- Loading -->
  <div class="state" *ngIf="listLoading" role="status">
    <span class="spinner" aria-hidden="true"></span> Loading schedules&hellip;
  </div>

  <!-- Error -->
  <div class="state state-err" *ngIf="!listLoading && listError" role="alert">
    <p>{{ listError }}</p>
    <button type="button" class="btn-outline" (click)="loadCalendar()">Try again</button>
  </div>

  <!-- Empty -->
  <div class="state" *ngIf="!listLoading && !listError && rows.length == 0">
    <p>No patch schedules yet.</p>
    <!-- <button type="button" class="btn-primary" (click)="openFilePicker()">
      <i class="fa fa-upload" aria-hidden="true"></i> Upload a schedule
    </button> -->
  </div>

  <div class="state" *ngIf="!listLoading && !listError && rows.length > 0 && filtered.length == 0">
    No schedules match these filters.
  </div>

  <!-- Table -->
  <div class="table-wrap" *ngIf="!listLoading && !listError && filtered.length > 0">
    <table class="grid">
      <caption class="visually-hidden">Patch schedules</caption>
      <thead>
        <tr>
          <th scope="col">Schedule</th>
          <th scope="col">Application</th>
          <th scope="col">Patch window (IST)</th>
          <th scope="col" class="num">Inst.</th>
          <th scope="col">Status</th>
          <th scope="col">Next notice</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of filtered; trackBy: trackRow">
          <td>
            <button type="button" class="link-btn" [disabled]="busy != 'idle'" (click)="openDetail(r.schedule_id)">
              {{ r.schedule_id }}
            </button>
          </td>
          <td>
            <div>{{ appText(r) }}</div>
            <div class="muted">{{ envText(r) }}</div>
          </td>
          <td>
            <div>{{ windowText(r) }}</div>
            <div class="muted" *ngIf="windowNote(r)">{{ windowNote(r) }}</div>
          </td>
          <td class="num">{{ r.instance_count }}</td>
          <td>
            <span class="pill" [ngClass]="statusClass(r)" [class.has-tip]="hasReason(r)"
              [attr.tabindex]="hasReason(r) ? 0 : null"
              [attr.aria-describedby]="tip && tip.id == r.schedule_id ? 'status-tip' : null"
              (mouseenter)="showTip($event, r)" (mouseleave)="hideTip()"
              (focus)="showTip($event, r)" (blur)="hideTip()">{{ statusLabel(r) }}</span>
          </td>
          <td>
            <ng-container *ngIf="nextNotice(r) as n">
              <div [class.muted]="n.muted">{{ n.title }}</div>
              <div class="muted" *ngIf="n.detail">{{ n.detail }}</div>
            </ng-container>
          </td>
        </tr>

      </tbody>
    </table>
  </div>

  <!-- Status tooltip -->
  <div class="tip-box" id="status-tip" role="tooltip" *ngIf="tip"
    [class.above]="tip.above" [style.left.px]="tip.x" [style.top.px]="tip.y">
    <div *ngFor="let line of tip.lines">{{ line }}</div>
  </div>
</section>

<!-- ============ Dialogs ============ -->
<app-edit-schedule *ngIf="dialog == 'edit' && detail"
  [form]="detail.form"
  [busy]="busy"
  (save)="saveEdit($event)"
  (dismiss)="closeDialog()">
</app-edit-schedule>

<app-cancel-schedule *ngIf="dialog == 'cancel' && detail"
  [form]="detail.form"
  [busy]="busy"
  (confirm)="confirmCancel($event)"
  (dismiss)="closeDialog()">
</app-cancel-schedule>

<app-check-schedule *ngIf="dialog == 'check' && detail"
  [result]="readiness"
  [state]="readinessState"
  [error]="readinessError"
  (recheck)="runCheck()"
  (dismiss)="closeDialog()">
</app-check-schedule>